var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"my-3"},[_c('page-show',{attrs:{"alias":'certificate'}}),_c('mail-form',{attrs:{"type":"Справка об отсутствии задолженности"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }